import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import { ApiBaseUrl, BranchUrl } from "../config/config";
import {
  AddUserRequest,
  BranchId,
  BranchIdRequest,
  DeleteUserRequest,
  Filter,
  GetBranchUsersResponse,
  getBreanchResponse,
  IBranchesRequest,
  IBranchesResponse,
  IBranchRequest,
  UpdateBranchesIbanRequest,
} from "../models/branch.model";

export const GetBranches = (
  request: IBranchesRequest
): Promise<ApiResultModel<IBranchesResponse[]>> => {
  return Axios.post<ApiResultModel<IBranchesResponse[]>>(
    ApiBaseUrl + BranchUrl + "/GetBranches",
    request
  ).then((result) => {
    return result.data;
  });
};

export const BranchAdd = (
  request: IBranchRequest
): Promise<ApiResultModel<boolean>> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + BranchUrl + "/Add",
    request
  ).then((result) => {
    return result.data;
  });
};
export const BranchUpdate = (
  request: IBranchRequest
): Promise<ApiResultModel<boolean>> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + BranchUrl + "/Update",
    request
  ).then((result) => {
    return result.data;
  });
};
export const BranchDelete = (
  request: BranchId
): Promise<ApiResultModel<boolean>> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + BranchUrl + "/Delete",
    request
  ).then((result) => {
    return result.data;
  });
};

export const GetBranch = (
  data: BranchId
): Promise<ApiResultModel<getBreanchResponse>> => {
  return Axios.get<ApiResultModel<getBreanchResponse>>(
    ApiBaseUrl + BranchUrl + "/GetBranch/" + data.id
  ).then((result) => {
    return result.data;
  });
};
export const UpdateBranchesIban = async (
  data: UpdateBranchesIbanRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + BranchUrl + "/UpdateBranchesIban",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetBranchesExcel = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + BranchUrl + "/GetBranchesExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` شعبات.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const GetBranchUsers = (
  data: BranchIdRequest
): Promise<ApiResultModel<GetBranchUsersResponse>> => {
  return Axios.get<ApiResultModel<GetBranchUsersResponse>>(
    ApiBaseUrl + BranchUrl + "/GetBranchUsers/" + data.branchId
  ).then((result) => {
    return result.data;
  });
};

export const AddUser = (
  request: AddUserRequest
): Promise<ApiResultModel<boolean>> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + BranchUrl + "/AddUser",
    request
  ).then((result) => {
    return result.data;
  });
};
export const DeleteUser = (
  request: DeleteUserRequest
): Promise<ApiResultModel<boolean>> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + BranchUrl + "/DeleteUser",
    request
  ).then((result) => {
    return result.data;
  });
};
